/* XGRITX homepage — reveal, parallax, crew scroll, FAQ, filters, AJAX cart drawer */
(function () {
  var XG = window.XG || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = XG.moneyFormat || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var withComma = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withComma);
  }

  /* reveal */
  function reveal() {
    var lim = window.innerHeight * 0.92;
    $$('.rv:not(.in), .split:not(.in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < lim) el.classList.add('in');
    });
  }

  /* nav */
  var nav = $('[data-nav]');
  function navState() { if (nav) nav.classList.toggle('solid', window.scrollY > 40); }

  /* parallax */
  var par = $('[data-parallax]');
  function parallax() {
    if (!par) return;
    var y = window.scrollY;
    if (y > window.innerHeight * 1.2) return;
    par.style.transform = 'translateY(' + (y * 0.35) + 'px) scale(' + (1.08 + y * 0.0002) + ')';
  }

  /* crew horizontal */
  var crew = $('[data-crew]'), track = $('[data-crew-track]'), prog = $('[data-crew-prog]');
  var crewDist = 0;
  function crewSize() {
    if (!crew || !track) return;
    crewDist = Math.max(0, track.scrollWidth - window.innerWidth + 80);
    crew.style.height = (window.innerHeight + crewDist) + 'px';
  }
  function crewScroll() {
    if (!crew || !track) return;
    var r = crew.getBoundingClientRect();
    var p = Math.min(1, Math.max(0, -r.top / Math.max(1, crewDist)));
    track.style.transform = 'translateX(' + (-p * crewDist) + 'px)';
    if (prog) prog.style.width = (p * 100) + '%';
  }

  var raf = 0;
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; reveal(); navState(); parallax(); crewScroll(); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { crewSize(); onScroll(); });
  window.addEventListener('load', function () { crewSize(); onScroll(); });

  /* FAQ */
  $$('[data-faq]').forEach(function (wrap) {
    $$('.qa > button', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qa = btn.parentNode, open = qa.classList.contains('open');
        $$('.qa', wrap).forEach(function (q) { q.classList.remove('open'); q.firstElementChild.setAttribute('aria-expanded', 'false'); });
        if (!open) { qa.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  });

  /* filters */
  $$('[data-xg-shop]').forEach(function (shop) {
    $$('[data-filter]', shop).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-filter');
        $$('[data-filter]', shop).forEach(function (c) { c.classList.toggle('on', c === chip); });
        $$('.cell', shop).forEach(function (cell) {
          cell.style.display = (f === 'all' || cell.getAttribute('data-type') === f) ? '' : 'none';
        });
        setTimeout(reveal, 30);
      });
    });
  });

  /* mobile menu */
  var menu = $('[data-menu]');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { menu.classList.add('on'); menu.setAttribute('aria-hidden', 'false'); }); });
  $$('[data-menu-close], [data-menu] a').forEach(function (b) { b.addEventListener('click', function () { menu.classList.remove('on'); menu.setAttribute('aria-hidden', 'true'); }); });

  /* cart drawer */
  var drawer = $('[data-cart-drawer]'), scrim = $('[data-cart-scrim]');
  function openCart() { if (!drawer) return; drawer.classList.add('on'); scrim.classList.add('on'); drawer.setAttribute('aria-hidden', 'false'); }
  function closeCart() { if (!drawer) return; drawer.classList.remove('on'); scrim.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true'); }
  $$('[data-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { if (!drawer) return; e.preventDefault(); refresh().then(openCart); }); });
  $$('[data-cart-close], [data-cart-scrim]').forEach(function (a) { a.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function render(cart) {
    $$('[data-cart-count]').forEach(function (c) {
      c.textContent = cart.item_count;
      c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump');
    });
    var sub = cart.total_price, th = XG.freeShip || 7500, left = Math.max(0, th - sub);
    var st = $('[data-ship-text]'), bar = $('[data-ship-bar]');
    if (st) st.textContent = left > 0 ? money(left) + ' away from free shipping' : 'Free shipping unlocked';
    if (bar) bar.style.width = Math.min(100, sub / th * 100) + '%';
    var sb = $('[data-cart-subtotal]'); if (sb) sb.textContent = money(sub);
    var box = $('[data-cart-items]'); if (!box) return;
    if (!cart.items.length) { box.innerHTML = '<div class="empty">Your cart is empty.<br>Time to gear up.</div>'; return; }
    box.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      return '<div class="item">' +
        '<a href="' + it.url + '" class="ph img-fill">' + (img ? '<img src="' + img + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a>' +
        '<div><h4>' + esc(it.product_title) + '</h4><div class="v">' + esc(variant) + '</div>' +
        '<div class="qty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '">+</button></div>' +
        '<button type="button" class="rm" data-line="' + (i + 1) + '" data-q="0">Remove</button></div>' +
        '<div class="pr">' + money(it.final_line_price) + '</div></div>';
    }).join('');
  }

  function refresh() {
    return fetch((XG.routes ? XG.routes.cart : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { render(c); return c; });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-line][data-q]');
    if (q) {
      fetch((XG.routes ? XG.routes.cartChange : '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: +q.getAttribute('data-line'), quantity: +q.getAttribute('data-q') })
      }).then(function (r) { return r.json(); }).then(render);
      return;
    }
    var add = e.target.closest('[data-quick-add]');
    if (add) {
      e.preventDefault();
      var label = add.innerHTML;
      add.classList.add('busy');
      fetch((XG.routes ? XG.routes.cartAdd : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +add.getAttribute('data-quick-add'), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add'); });
        return refresh();
      }).then(function () {
        add.classList.remove('busy'); add.classList.add('ok'); add.innerHTML = 'Added ✓';
        setTimeout(function () { add.classList.remove('ok'); add.innerHTML = label; }, 1400);
        openCart();
      }).catch(function (err) {
        add.classList.remove('busy'); add.innerHTML = esc(err.message);
        setTimeout(function () { add.innerHTML = label; }, 2000);
      });
    }
  });

  reveal(); navState(); parallax(); crewSize(); crewScroll();
  setTimeout(reveal, 120); setTimeout(reveal, 800);
  refresh().catch(function () {});

  /* theme editor support */
  document.addEventListener('shopify:section:load', function () { crewSize(); reveal(); });
})();

/* ---- product page + collection filters ---- */
(function () {
  var XG = window.XG || {};
  function money(c) {
    var fmt = XG.moneyFormat || '${{amount}}', v = (c / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  var pdp = document.querySelector('[data-pdp]');
  if (pdp) {
    var variants = []; try { variants = JSON.parse(pdp.querySelector('[data-variants]').textContent); } catch (e) {}
    var form = pdp.querySelector('[data-pdp-form]');
    var idInput = pdp.querySelector('[data-variant-id]');
    var addBtn = pdp.querySelector('[data-add]'), addLabel = pdp.querySelector('[data-add-label]');
    var priceEl = pdp.querySelector('[data-price]'), cmpEl = pdp.querySelector('[data-compare]');
    var main = pdp.querySelector('[data-pdp-main]'), err = pdp.querySelector('[data-pdp-err]');
    var thumbs = [].slice.call(pdp.querySelectorAll('[data-thumb]'));

    function showImg(src, mediaId) {
      var img = main && main.querySelector('img'); if (!img || !src) return;
      img.style.opacity = 0;
      setTimeout(function () { img.removeAttribute('srcset'); img.src = src; img.onload = function () { img.style.opacity = 1; }; }, 150);
      thumbs.forEach(function (t) { t.classList.toggle('on', String(t.getAttribute('data-media-id')) === String(mediaId)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showImg(t.getAttribute('data-thumb'), t.getAttribute('data-media-id')); }); });

    function selected() { return [].slice.call(pdp.querySelectorAll('.opt')).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
    function find(sel) { return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }); }

    function markAvailability(sel) {
      pdp.querySelectorAll('.opt').forEach(function (fs, idx) {
        fs.querySelectorAll('label.chip').forEach(function (lab) {
          var val = lab.querySelector('input').value;
          var test = sel.slice(); test[idx] = val;
          var v = find(test);
          lab.classList.toggle('na', !v || !v.available);
        });
      });
    }

    function update() {
      var sel = selected();
      pdp.querySelectorAll('.opt').forEach(function (fs, i) {
        fs.querySelectorAll('label.chip').forEach(function (l) { l.classList.toggle('on', l.querySelector('input').checked); });
        var lb = fs.querySelector('[data-opt-label]'); if (lb) lb.textContent = sel[i] || '';
      });
      markAvailability(sel);
      var v = find(sel);
      if (!v) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      if (v.compare_at_price > v.price) { cmpEl.hidden = false; cmpEl.textContent = money(v.compare_at_price); } else { cmpEl.hidden = true; }
      addBtn.disabled = !v.available; addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.featured_media && v.featured_media.preview_image) {
        var src = v.featured_media.preview_image.src; src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=1800';
        showImg(src, v.featured_media.id);
      }
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    }
    pdp.querySelectorAll('[data-opt]').forEach(function (r) { r.addEventListener('change', update); });
    if (pdp.querySelector('.opt')) markAvailability(selected());

    var qty = pdp.querySelector('[data-qty]');
    pdp.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10)); });
    });

    if (form) form.addEventListener('submit', function (e) {
      if (!document.querySelector('[data-cart-drawer]')) return;
      e.preventDefault();
      err.hidden = true;
      var old = addLabel.textContent; addBtn.disabled = true; addLabel.textContent = 'Adding…';
      fetch((XG.routes ? XG.routes.cartAdd : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +idInput.value, quantity: Math.max(1, parseInt(qty.value, 10) || 1) }] })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
        .then(function () {
          addLabel.textContent = 'Added ✓';
          var opener = document.querySelector('[data-cart-open]'); if (opener) opener.click();
          setTimeout(function () { addLabel.textContent = old; addBtn.disabled = false; }, 1400);
        })
        .catch(function (ex) { err.textContent = ex.message; err.hidden = false; addLabel.textContent = old; addBtn.disabled = false; });
    });
  }

  /* collection: auto-submit filters & sort */
  var cf = document.querySelector('[data-coll-form]');
  if (cf) {
    cf.addEventListener('change', function (e) {
      if (!e.target.matches('[data-auto]')) return;
      var fd = new FormData(cf), p = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
      location.search = p.toString();
    });
    cf.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(cf), p = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
      location.search = p.toString();
    });
    document.addEventListener('click', function (e) {
      cf.querySelectorAll('details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }
})();
